<template>
  <NavigationMenu :expanded="isExpanded" @onToggleClick="toggleMenu">
    <template #search>
      <IndoorviewerMenuSearchField @search="onSearchResults" />
    </template>
    <div>
      <IndoorviewerMenuSearchResult
        v-show="hasSearchResults"
        :searchResults="searchResults"
        :searchString="searchString"
        @close="clearSearchResults"
      />
      <IndoorviewerMenuView v-if="selectedBuildingId.length && ivLevelsFrame1" />
      <IndoorviewerMenuPoi />
    </div>
  </NavigationMenu>
</template>

<script>
import IndoorviewerMenuSearchField from './IndoorviewerMenuSearchField.vue'
import IndoorviewerMenuSearchResult from './IndoorviewerMenuSearchResult.vue'
import IndoorviewerMenuView from './IndoorviewerMenuView.vue'
import NavigationMenu from '@/components/general/navigation/NavigationMenu.vue'
import { ivApi } from '@/components/indoorviewer/IndoorviewerView.vue'
import IndoorviewerMenuPoi from '@/components/indoorviewer/menu/IndoorviewerMenuPoi.vue'
import { mapGetters, mapState } from 'vuex'
import { INDOORVIEWER_PREFIX, MAPVIEW_PREFIX } from '@/store/module-prefixes'
import iconShare from '@/assets/icon-share.svg'
export default {
  name: 'IndoorviewerMenu',
  components: {
    IndoorviewerMenuPoi,
    IndoorviewerMenuSearchField,
    IndoorviewerMenuSearchResult,
    IndoorviewerMenuView,
    NavigationMenu
  },
  emits: ['toggleMenu'],
  data() {
    return {
      shareSource: iconShare,
      isExpanded: false,
      hasSearchResults: false,
      searchResults: [],
      searchString: ''
    }
  },
  computed: {
    buttonImgSource() {
      return this.isExpanded ? this.crossSource : this.hamburgerSource
    },
    ...mapGetters(MAPVIEW_PREFIX, {
      selectedBuildingId: 'selectedBuildingId'
    }),
    ...mapState(INDOORVIEWER_PREFIX, {
      ivLevelsFrame1: (state) => state.ivLevelsFrame1
    })
  },
  methods: {
    toggleMenu() {
      this.isExpanded = !this.isExpanded
      this.$emit('toggleMenu', !this.isExpanded)
    },
    onSearchResults(data) {
      this.searchResults = data.result
      this.searchString = data.searchInput
      this.hasSearchResults = true
      this.isExpanded = true
      this.$emit('toggleMenu', !this.isExpanded)
    },
    generateShareUrl() {
      let url = ivApi.share.generateShareUrl()
      const copyElement = document.createElement('textarea')
      copyElement.value = url
      document.body.appendChild(copyElement)
      copyElement.select()
      document.execCommand('copy')
      document.body.removeChild(copyElement)
    },
    clearSearchResults() {
      this.searchResults = []
      this.hasSearchResults = false
    }
  }
}
</script>
